module.exports = __webpack_public_path__ + "static/beachhouse-47798a3e2a5737dea604c94e02a37c86.jpg";